import * as R from 'ramda'
import { ListQueryProps } from '../Select'

type Props = {
  listQueryProps: ListQueryProps
}

export const ShowSkeletonOptions = ({ listQueryProps }: Props) => {
  const { loading, take } = listQueryProps

  if (!loading) return null
  return (
    <div className='w-full h-full overflow-hidden space-y-1'>
      {R.range(0, take).map((i) => (
        <div className='w-full h-full px-2' key={'skeleton-option' + i}>
          <div className='h-6 w-full rounded-lg bg-slate-200 animate-pulse transition'></div>
        </div>
      ))}
    </div>
  )
}
